import React, { useContext, useEffect, useState } from "react";
import './abmProveedores.css';
import * as XLSX from 'xlsx';
import { createEstructuraABMProveedor, createEstructuraProveedor } from "../../utils/estructuras";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faBackspace} from "@fortawesome/free-solid-svg-icons";
import { useRef } from "react";
import productsContext from "../../context/productos/productsContext";
import Swal from 'sweetalert2';
import categoriasRRHHContext from "../../context/categoriasRRHHContext/categoriasRRHHContex";
import proveedorContext from "../../context/proveedoresContext/proveedorContext";
import Select from 'react-select';


const AbmProveedores = ({setShowAbm = () => console.log('Cerrar'), proveedorToEdit = {}, setProveedorToEdit = () => console.log('Set product to edit')}) => {
    const [proveedorEditing,setProveedorEditing] = useState(proveedorToEdit);
    const [proveedoresData,setProveedoresData] = useState([createEstructuraABMProveedor()]);
    const [categoriasError,setCategoriasError] = useState([]);
    const fileInputRef = useRef(null);

    console.log("proveedorToEdit en aBM");
    console.log(proveedorToEdit);
    

    const {proveedoresList,agregarProveedor,modificarProveedor,actualizarProveedoresList,eliminarProveedor} = useContext(proveedorContext);

    const handleChange = (e, i = -1, catego = {}) =>{
        if(Object.keys(proveedorEditing).length > 0){
            const {name,value} = e.target;
            setProveedorEditing({...proveedorEditing, [name]: value});
        }else{
            setProveedoresData((prevData) => {
                let newProveedores = prevData.slice();
                
                const {name,value} = e.target;
                if(value != ''){
                    if(newProveedores[i].codigo != '' && newProveedores[i].nombre != ''){
                        newProveedores[i][name] = value;
                    }else{
                        newProveedores[i][name] = value;
                        newProveedores.length == i+1 && newProveedores.push(createEstructuraABMProveedor());
                    }
                }else{
                    newProveedores[i][name] = value;
                    if(newProveedores[i].nroCta == '' && newProveedores[i].nombre == '' ){
                        newProveedores.splice(i,1);
                    }
                }
                return newProveedores;
            })
        }

    }

    const handleFile = (file) => {
        if(file){
            const reader = new FileReader();
            reader.onload = (evt) => {
                const binaryString = evt.target.result;
                const wb = XLSX.read(binaryString, {type: 'binary'});
                const sheet = wb.Sheets[wb.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(sheet,{header:1});

                let dataModelated = jsonData.filter((l,i) => (i > 0 && l.length > 0)).map((l,i) => {
                    let objectModelated;
                    l.forEach((value,index) => {
                        switch(index){
                            case 0: 
                                objectModelated = {nroCta: value};
                                break;
                            case 1:
                                objectModelated = {...objectModelated, nombre: value};
                                break;
                        }
                        objectModelated = {...objectModelated, origen:'M'};
                    })
                    return objectModelated
                });
                if(proveedoresData.length > 0){
                    setProveedoresData((prevProveedores) => {
                        let newProveedores = [...dataModelated];
                        newProveedores = [...newProveedores, ...prevProveedores.filter(l => !dataModelated.some((lD) => lD.nroCta == l.nroCta || lD.nombre == l.nombre))];
                        return newProveedores
                    });
                }else{
                    setProveedoresData([...dataModelated]);
                }
            }
            reader.readAsBinaryString(file);
        }
    }

    const handleChangeFile = (e) => {
        const file = e.target.files[0];
        handleFile(file);
    }

    const handleDelete = (prod,i) => {
        if(prod.codigo != ''){
            setProveedoresData((prevData) => {
                let newData = prevData.filter((p,index) => index != i);
                return newData;
            })
        }
    }

    const handleSave = async() => {
        if(Object.keys(proveedorEditing).length > 0){
            let proveedorModelated = {...proveedorEditing};
            let res = await modificarProveedor(proveedorModelated);
            if(res){
                Swal.fire({
                    title:'Éxito!',
                    text:'Proveedor actualizado correctamente',
                    icon:'success'
                })
            }
        }else{
            if(proveedoresData.some((l,i) => i < proveedoresData.length - 1 && (l.nroCta == '' || l.nombre == ''))){
                let result = await Swal.fire({
                    title: `Ops!`,
                    icon: 'warning',
                    text: 'Ciertos proveedores estan sin completar, desea omitirlos y guardar igual?',
                    showConfirmButton: true,
                    showCancelButton: true, // Habilita el botón de cancelar
                    confirmButtonColor: '#ff0000',
                    denyButtonColor: '#3d4d87',
                    confirmButtonText: 'Sí, estoy seguro',
                    cancelButtonText:'No',
                    allowEnterKey: true
                })
                if (result.isConfirmed ) {
                }else{
                    return false;
                }
            }
            let proveedoresCompleted = proveedoresData.filter((l) => l.nroCta != '' && l.nombre != '');
            
            proveedoresCompleted = proveedoresCompleted.map((l) => ({...l}));
            let counterSaved = 0;
            let counterFail = 0;
            for(const p of proveedoresCompleted){
                try {
                    let res = await agregarProveedor(p);
                    if(res == null) throw new Error("Clave Duplicada para el Proveedor " + p.nroCta);
                    counterSaved++;
                } catch (error) {
                    console.log("error intentando guardar el nuevo proveedor " + p.nroCta + ' ' +p.nombre);
                    console.log(error);
                    counterFail++;
                }
            }
            actualizarProveedoresList();
            Swal.fire({
                title:'Contador',
                icon: counterFail == 0 && counterSaved > 0 ? 'success' : counterFail > 0 && counterSaved == 0 ? 'error' : 'warning',
                html: `Proveedores guardados con Éxito: ${counterSaved}. <br>
                Proveedores imposibles de guardarlos: ${counterFail}`,
            })
        }
        handleClose();
    }

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFile = e.dataTransfer.files[0];
        handleFile(droppedFile);
    }

    const handleClose = () => {
        if(Object.keys(proveedorToEdit).length > 0){
            setProveedorEditing({});
            setProveedorToEdit({});
        }
        setShowAbm(false)
    }

    return <div className="abmProveedoresModal">
        <div className="abmProductsDiv">
            <button className="minimizarBtn" onClick={handleClose}>X</button>
            <h2>{Object.keys(proveedorEditing).length == 0 ? 'Alta de Proveedor' : 'Edición de Proveedor'}</h2>
            <div className="proveedoresLeidosSubtabla">
                <div className={`${Object.keys(proveedorEditing).length == 0 ? '' : 'fiveColumns'} labelsSubtablas`}>
                    {Object.keys(proveedorEditing).length == 0 && <label></label>}
                    <label>Núm. Cuenta</label>
                    <label>Nombre</label>
                </div>
                {Object.keys(proveedorEditing).length > 0 
                ? 
                <div className={`${Object.keys(proveedorEditing).length == 0 ? '' : 'fiveColumns'} proveedorLoaded`}>
                    <input name="nroCta" onChange={(e)=>handleChange(e)} value={proveedorEditing.nroCta}></input>
                    <input name="nombre" onChange={(e)=>handleChange(e)} value={proveedorEditing.nombre}></input>
                </div> 
                : 
                proveedoresData.map((c,i) => <div className="proveedorLoaded" key={i}>
                    <FontAwesomeIcon className="iconDelete" icon={faBackspace} color="red" onClick={(e)=>handleDelete(c,i)}/>
                    <input name="nroCta" onChange={(e)=>handleChange(e,i)} value={c.nroCta}></input>
                    <input name="nombre" onChange={(e)=>handleChange(e,i)} value={c.nombre}></input>
                    
                </div>)}
            </div>
            {Object.keys(proveedorEditing).length == 0 && <a href="/templateProveedor.xlsx" download>Descargar template.xlsx</a>}
            {Object.keys(proveedorEditing).length == 0 && <div className="inputFileXlsx dropNivel1" 
                onClick={() => fileInputRef.current.click()}
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDrop}
            >
                <span  accept=".xlsx,.xls" htmlFor='excelFile'>O cargue los proveedores arrastrando un archivo .xlsx a esta sección</span>
                <input ref={fileInputRef} type="file" id="excelFile" style={{display:'none'}} onChange={(e)=>handleChangeFile(e)} />
            </div>}
            <button className="saveBtn" onClick={handleSave}>Guardar</button>
        </div>
    </div>
}

export default AbmProveedores;